import type { User } from "~/models/User";
import { AccessType } from "~/enums/accesstypes";

/** Navigates to the start page that belongs to the access type of the logged in user. */
export const navigateAfterLogin = () => {
  const userData = sessionStorage.getItem("user");
  if (!userData) {
    return navigateTo("/login");
  }

  const user: User = JSON.parse(userData);
  switch (user.accessType) {
    case AccessType.Admin:
    case AccessType.Keurmeister:
      return navigateTo("/");
    case AccessType.CustUser:
    case AccessType.UserAdmin:
    case AccessType.custProductMover:
      return navigateTo("/locations");
    case AccessType.Transporter:
      return navigateTo("/transporter");
  }
};
